<template>
  <form>
    <ul class="set_form">
      <li
          v-for="(field, index_i) in fields"
          :key="index_i"
          :class="field.class"
      >
        <label
            v-for="(item, index_j) in field.items"
            :key="index_j"
            :for="item.id"
            class="member_input"
        >
          <input
              :id="item.id"
              :name="item.name"
              :class="item.class"
              :type="item.type"
              :autocomplete="item.autocomplete"
              v-model="item.value"
              :maxlength="item.maxlength"
              @input="item.event(item, index_i, index_j)"
              @blur="item.event(item, index_i, index_j)"
          >
          <span class="label item-title">{{ $t(`${item.title}`) }} {{ item.required ? '*' : '' }}</span>
          <span
              v-if="!item.validation && item.class.includes(red) && item.description"
              :class="item.class.includes(red) ? 'description red' : 'description'"
          >
              ※ {{ $t(`${item.description}`) }}
          </span>
        </label>
        <BlindIcon
            :index_i="index_i"
            @togglePasswordShow="togglePasswordShow"
            class="tempBlindStyle"
        />
      </li>
    </ul>
  </form>
</template>
<script>
import _API from "../../../../../api";
import validationMethods from '@/common/lib/validation.js';
import BlindIcon from "../../../../form/blindIcon";

export default {
  name: 'ChangePwForm',
  components: {BlindIcon},
  data() {
    return {
      red: 'red_wrong',
      fields: [
        {
          index: 0,
          class: '',
          items: [
            {
              id: 'currentPassword',
              class: ['input-masking'],
              title: 'account.current_password',
              type: 'new-password',
              value: '',
              required: true,
              validation: false,
              description: 'account.current_password_required',
              autocomplete: 'off',
              maxlength: 50,
              event: this.checkEachValidation
            }
          ]
        },
        {
          index: 1,
          class: '',
          items: [
            {
              id: 'newPassword',
              class: ['input-masking'],
              title: 'account.new_password',
              type: 'new-password',
              value: '',
              required: true,
              validation: false,
              description: '',
              autocomplete: 'new-password',
              maxlength: 50,
              event: this.checkEachValidation
            }
          ]
        },
        {
          index: 2,
          class: '',
          items: [
            {
              id: 'confirmPassword',
              class: ['input-masking'],
              title: 'account.confirm_password',
              type: 'new-password',
              value: '',
              required: true,
              validation: false,
              description: 'account.password_re_same',
              autocomplete: 'off',
              maxlength: 50,
              event: this.checkEachValidation
            }
          ]
        }
      ]
    }
  },
  methods: {
    ...validationMethods,
    changePassword() {
      this.checkIfNotEntered();
      const pass = (this.fields[0].items[0].validation && this.fields[1].items[0].validation && this.fields[2].items[0].validation);

      if (pass) {
        const data = {
          currentPW: this.fields[0].items[0].value,
          newPW: this.fields[1].items[0].value
        }
        return new Promise((resolve, reject) => {
          _API.USER.changePassword(data)
              .then(res => {
                if (res.data.isSuccess) {
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'account.completed_change_password'
                  });
                  this.fields.forEach(field => field.items[0].value = '');
                  resolve();
                } else if (res.data.isSuccess === false && res.data.failedCode === 1) {
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'account.password_pair_mismatch'
                  });
                  this.changeValidation(false, 0, 0);
                } else {
                  reject(`[changePassword] failedCode = ${res.data.failedCode}`);
                }
              })
              .catch(e => {
                reject(`[changePassword] ${e}`)
              });
        });
      }
    },
    /**
     * 비밀번호의 input 타입을 변경해, 보여주거나 감춘다.
     * @param booleans
     */
    togglePasswordShow(booleans, index_i) {
      if (booleans) {
        this.fields[index_i].items[0].class.removeItem('input-masking');
      } else {
        this.fields[index_i].items[0].class.pushIfNotExist('input-masking');
      }
    },
    /**
     * fields 에 index_i, index_j 에 해당하는 아이템의 유효성 상태와
     * 클래스를 변경한다. (빨강 경고 문구 표기)
     * @param validationCheck
     * @param index_i
     * @param index_j
     */
    changeValidation(validationCheck, index_i, index_j) {
      if (validationCheck) {
        this.fields[index_i].items[index_j].class.removeItem(this.red);
      } else {
        this.fields[index_i].items[index_j].class.pushIfNotExist(this.red)
      }
      this.fields[index_i].items[index_j].validation = validationCheck;
    },
    /**
     *  각 필드를 사용자가 클릭 후 떠나면 (@blur) or (@change, @input)
     *  유효성을 체크한다.
     * @param id
     * @param value
     * @param index_i
     * @param index_j
     */
    checkEachValidation({id, value}, index_i, index_j) {
      let validationCheck = false;
      switch (id) {
        case 'currentPassword' :
            validationCheck = value.length > 0;
          break
        case 'newPassword' :
          if (value.length > 0 && value === this.fields[index_i - 1].items[index_j].value) {
            // 기존 패스워드와 일치한다면,
            this.fields[index_i].items[index_j].description = 'account.old_new_password_not_same';
          } else {
            this.fields[index_i].items[index_j].description = 'account.password_form';
            validationCheck = this.checkPasswordValidation(value).result;
          }
          break
        case 'confirmPassword' :
          validationCheck = value.length > 0 && this.fields[index_i - 1].items[index_j].value === value;
          break
        default :
          break
      }
      this.changeValidation(validationCheck, index_i, index_j);
    },
    /**
     * validation 이 false 인 아이템 빨강 경고 표시
     */
    checkIfNotEntered() {
      this.fields.forEach((field, index_i) => {
        field.items.forEach((item, index_j) => {
            this.checkEachValidation(item, index_i, index_j);
        })
      });
    }
  }
}
</script>
<style lang="scss">
/* 컴포넌트화 전 임시 사용 */
.tempBlindStyle {
  &.blind_icon {
    top: 34px;
  }
}

.set_form {
  li {
    label {
      input {
        box-sizing: border-box;
      }
    }
  }

  input {
    padding-right: 65px;
    width: 100% !important;
  }

  input:focus {
    border: 1px solid var(--blue70);
  }

  input:disabled {
    background-color: var(--grey10) !important;
  }

  .red_wrong {
    border: 1px solid var(--error20) !important;
    background: var(--error10) !important;
    transition: 0.3s;
  }
}
</style>